// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const retweetsHistoryConfig = {
    title: 'chart.twitter.retweets_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.twitter.retweets_history_name',
        avg: 'chart.twitter.retweets_history_avg'
    },
    id: 'retweets_history',
    color: {
        value: 'aquablue',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.tiktok.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
